import { render } from "./Modal.vue?vue&type=template&id=044e6af0"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render

export default script